import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class OfferResource extends AuthenticatedResource {
  static urlRoot = '/offers' as const

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}